var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Alert, AlertIcon, Badge, Button, Flex, Image, InputGroup, InputRightElement, Stack, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useState } from 'react';
import { ResultSkeleton } from "./resultskeleton";
import { Filterskeleton } from "./filterskeleton";
import { Result } from "./result";
import { AutoComplete, AutoCompleteInput, AutoCompleteItem, AutoCompleteList } from "@choc-ui/chakra-autocomplete";
export const Search = (props) => {
    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [searchResponse, setSearchResponse] = useState(null);
    const [filter, setFilter] = useState(null);
    const [offset, setOffset] = useState(0);
    const trackSearchResults = (data) => __awaiter(void 0, void 0, void 0, function* () {
        if (typeof Matomo === "object" && typeof Matomo.getTracker === "function" && typeof Matomo.getTracker().trackSiteSearch === "function") {
            Matomo.getTracker().trackSiteSearch(query, false, data.count);
        }
    });
    const start = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setOffset(0);
        const params = new URLSearchParams({ query });
        if (props.scope) {
            params.append("scope", props.scope);
        }
        const result = yield fetch("/api/search?" + params.toString());
        const data = yield result.json();
        setSearchResponse(data);
        setLoading(false);
        trackSearchResults(data);
    });
    const loadMore = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingMore(true);
        const params = new URLSearchParams({ query, offset: (offset + 10).toString() });
        if (props.scope) {
            params.append("scope", props.scope);
        }
        const result = yield fetch("/api/search?" + params.toString());
        const data = yield result.json();
        if (searchResponse === null) {
            setLoadingMore(false);
            return;
        }
        const newResults = [...searchResponse.results, ...data.results];
        setSearchResponse(Object.assign(Object.assign({}, searchResponse), { results: newResults }));
        setLoadingMore(false);
        setOffset(offset + 10);
    });
    const loadSuggestion = () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield fetch("/api/suggest?query=" + query);
        const data = yield result.json();
        setSuggestions(data.suggestions);
    });
    useEffect(() => {
        loadSuggestion();
    }, [query]);
    return (React.createElement(VStack, { spacing: 6, width: "100%", alignItems: "stretch" },
        React.createElement(Flex, { justifyContent: "center", p: [4, 8, 16] },
            React.createElement(InputGroup, { size: 'md', maxWidth: "600px" },
                React.createElement(AutoComplete, { openOnFocus: true, onSelectOption: (params) => setQuery(params.item.value) },
                    React.createElement(AutoCompleteInput, { variant: "filled", fontSize: "1.6rem", pr: '4.5rem', placeholder: 'REA Card durchsuchen', value: query, onChange: (event) => setQuery(event.target.value), paddingY: 8, paddingX: 10, borderRadius: 8, onKeyDown: (event) => {
                            if (event.key === "Enter") {
                                start();
                            }
                        } }),
                    React.createElement(InputRightElement, { width: '4.5rem', height: "100%" },
                        React.createElement(Button, { onClick: () => start() },
                            React.createElement(Image, { src: require('../../assets/magnifying-glass-light.svg'), width: 6, height: 6 }))),
                    suggestions.length > 0 ?
                        React.createElement(AutoCompleteList, { backgroundColor: "white" }, suggestions.map((suggestion, cid) => (React.createElement(AutoCompleteItem, { key: `option-${cid}`, value: suggestion, textTransform: "capitalize", _selected: { bg: "reaBlue.50" }, _focus: { bg: "reaBlue.100" } }, suggestion))))
                        : null))),
        React.createElement(Stack, { width: "100%", spacing: 10, alignItems: "flex-start", direction: ["column", "column", "row"] },
            React.createElement(VStack, { flex: 1, width: "100%", maxWidth: { md: "300px" }, spacing: 4, alignItems: "stretch" }, loading ?
                React.createElement(Filterskeleton, null)
                :
                    (searchResponse !== null ?
                        (searchResponse.aggregates.map((aggregate) => (React.createElement(Button, { variant: aggregate.type === filter ? "solid" : "outline", colorScheme: aggregate.type === filter ? "reaBlue" : "gray", justifyContent: "flex-start", leftIcon: React.createElement(Image, { src: require('../../assets/file-light.svg'), width: 6, height: 6 }), rightIcon: React.createElement(Badge, null, aggregate.count), onClick: () => {
                                setFilter(aggregate.type === filter ? null : aggregate.type);
                            } },
                            React.createElement(Text, { textAlign: "left", flex: 1 }, aggregate.name)))))
                        : null)),
            React.createElement(VStack, { flex: 1, spacing: 8, alignItems: "flex-start" }, loading ?
                React.createElement(React.Fragment, null,
                    React.createElement(ResultSkeleton, null),
                    React.createElement(ResultSkeleton, null),
                    React.createElement(ResultSkeleton, null),
                    React.createElement(ResultSkeleton, null))
                :
                    (searchResponse !== null ?
                        React.createElement(React.Fragment, null, searchResponse.results.length > 0 ?
                            React.createElement(React.Fragment, null,
                                React.createElement(Text, { textAlign: "left", color: "gray.500" },
                                    "Zeige ",
                                    React.createElement("em", null, searchResponse.results.length),
                                    " von ",
                                    React.createElement("em", null, searchResponse.count),
                                    " Ergebnissen"),
                                searchResponse.restricted &&
                                    React.createElement(Alert, { status: "info", variant: "subtle" },
                                        React.createElement(AlertIcon, null),
                                        "Das Suchergebnis enth\u00E4lt ausgeblendete Ergebnisse. Loggen Sie sich ein, um m\u00F6glicherweise mehr Ergebnisse zu erhalten."),
                                searchResponse.results.map((result) => (filter === null || result.type === filter) &&
                                    React.createElement(Result, { key: result.title, result: result })),
                                loadingMore &&
                                    React.createElement(React.Fragment, null,
                                        React.createElement(ResultSkeleton, null),
                                        React.createElement(ResultSkeleton, null),
                                        React.createElement(ResultSkeleton, null),
                                        React.createElement(ResultSkeleton, null)),
                                offset < searchResponse.count &&
                                    React.createElement(Flex, { justifyContent: "center" },
                                        React.createElement(Button, { onClick: () => loadMore(), isLoading: loadingMore }, "Mehr laden")))
                            :
                                React.createElement(React.Fragment, null,
                                    React.createElement(Text, null, "Leider konnten f\u00FCr Ihre Sucheingabe keine Ergebnisse gefunden werden.")))
                        : null)))));
};
